import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (e2) {
      setErr(apiErr(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background grain">
      <div className="w-full max-w-sm relative z-10">
        <h1 className="font-heading text-2xl font-extrabold uppercase mb-2">Reset password</h1>
        {done ? (
          <div className="card-industrial p-5" data-testid="forgot-confirm">
            <p className="text-sm text-muted-foreground">
              If that email is registered, a reset link has been sent. Check your inbox.
            </p>
            <Link to="/login" className="text-sm text-primary hover:underline mt-4 inline-block">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-muted-foreground">Enter your email and we'll send a reset link.</p>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                data-testid="forgot-email" className="mt-1" />
            </div>
            {err && <p className="text-sm text-red-400">{err}</p>}
            <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full font-bold uppercase">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
            </Button>
            <Link to="/login" className="text-sm text-muted-foreground hover:text-primary block text-center">Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
